import { render, staticRenderFns } from "./Declare.vue?vue&type=template&id=f5f9e930&scoped=true&"
import script from "./Declare.vue?vue&type=script&lang=js&"
export * from "./Declare.vue?vue&type=script&lang=js&"
import style0 from "./Declare.vue?vue&type=style&index=0&id=f5f9e930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f9e930",
  null
  
)

export default component.exports